import React from "react";
import "../App.css";

const HomePage: React.FC = () => {
  return (
    <div className="landing-container" style={{ fontFamily: 'sans-serif', maxWidth: 1200, margin: '0 auto', padding: 24 }}>
      {/* Hero Section */}
      <header style={{ textAlign: 'center', marginBottom: 60, padding: '40px 0' }}>
        <h1 style={{ fontSize: 48, margin: 0, color: '#2c3e50', fontWeight: 'bold' }}>ScanNChat</h1>
        <p style={{ fontSize: 24, color: '#7f8c8d', marginTop: 16, maxWidth: 600, margin: '16px auto 0' }}>
          Your time is precious. Why waste it sending emails or messages just to share a simple text or link between your devices?
        </p>
        <div style={{ marginTop: 32 }}>
          <button style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
            color: '#fff', 
            border: 'none', 
            padding: '16px 32px', 
            borderRadius: 50, 
            fontSize: 18, 
            cursor: 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
          }}>
            Get Started Now
          </button>
        </div>
      </header>

      {/* One App, All Your Devices */}
      <section style={{ marginBottom: 60, textAlign: 'center' }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 24 }}>One Application. All Your Devices.</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 32, marginTop: 40 }}>
          <div style={{ background: '#f8f9fa', padding: 32, borderRadius: 16, border: '1px solid #e9ecef' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📱</div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>Copy on Phone</h3>
            <p style={{ color: '#6c757d' }}>Copy any text, link, or message on your mobile device</p>
          </div>
          <div style={{ background: '#f8f9fa', padding: 32, borderRadius: 16, border: '1px solid #e9ecef' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚡</div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>Instant Sync</h3>
            <p style={{ color: '#6c757d' }}>Real-time synchronization via Firebase Realtime Database</p>
          </div>
          <div style={{ background: '#f8f9fa', padding: 32, borderRadius: 16, border: '1px solid #e9ecef' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>💻</div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>Paste on PC</h3>
            <p style={{ color: '#6c757d' }}>Instantly access your copied content on desktop or web</p>
          </div>
        </div>
      </section>

      {/* Privacy Protection */}
      <section style={{ marginBottom: 60, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: 40, borderRadius: 20, color: 'white' }}>
        <h2 style={{ fontSize: 36, marginBottom: 24, textAlign: 'center' }}>Protect Your Privacy</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 24 }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🕒</div>
            <h3 style={{ marginBottom: 16 }}>Ephemeral Messages</h3>
            <p>Your messages disappear after a defined time. No trace if you don't want it.</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
            <h3 style={{ marginBottom: 16 }}>Secure & Private</h3>
            <p>Chat with strangers without sharing personal information</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🛡️</div>
            <h3 style={{ marginBottom: 16 }}>Encrypted Data</h3>
            <p>All your data is encrypted and secured with Firebase Authentication</p>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section style={{ marginBottom: 60 }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 40, textAlign: 'center' }}>Key Features</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: 32 }}>
          <div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>🔗 Universal Synchronization</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              Copy a message, text, or link on your phone and paste it on your desktop, and vice versa. 
              Instant synchronization via Firebase Realtime Database.
            </p>
          </div>
          <div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>📷 QR Code Scanner</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              Quick and secure connection via QR code between different devices. 
              Easily associate a new device to your account.
            </p>
          </div>
          <div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>🌙 Customizable Interface</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              Choose between light and dark themes. Clean, fast, and responsive interface 
              designed for the best user experience.
            </p>
          </div>
          <div>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>👥 Account Management</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              Login via Firebase Authentication (email, social networks). 
              Free and premium accounts available.
            </p>
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section style={{ marginBottom: 60 }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 40, textAlign: 'center' }}>See ScanNChat in Action</h2>
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
          <img src="" alt="Mobile app home screen" style={{ width: 200, height: 400, background: '#f8f9fa', objectFit: 'cover', borderRadius: 16, border: '2px solid #e9ecef' }} />
          <img src="" alt="Private messages interface" style={{ width: 200, height: 400, background: '#f8f9fa', objectFit: 'cover', borderRadius: 16, border: '2px solid #e9ecef' }} />
          <img src="" alt="Ephemeral discussions" style={{ width: 200, height: 400, background: '#f8f9fa', objectFit: 'cover', borderRadius: 16, border: '2px solid #e9ecef' }} />
          <img src="" alt="QR code scanning" style={{ width: 200, height: 400, background: '#f8f9fa', objectFit: 'cover', borderRadius: 16, border: '2px solid #e9ecef' }} />
        </div>
        <p style={{ color: '#888', fontSize: 14, marginTop: 16, textAlign: 'center' }}>
          Add your mobile app screenshots here to showcase the interface
        </p>
      </section>

      {/* Pricing Section */}
      <section style={{ marginBottom: 60, background: '#f8f9fa', padding: 40, borderRadius: 20 }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 40, textAlign: 'center' }}>Free... and Even Better!</h2>
        <p style={{ textAlign: 'center', fontSize: 18, color: '#6c757d', marginBottom: 40 }}>
          Enjoy the essentials for free or unlock longer durations with our premium offers.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 32 }}>
          <div style={{ background: 'white', padding: 32, borderRadius: 16, textAlign: 'center', border: '2px solid #e9ecef' }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>Free</h3>
            <div style={{ fontSize: 48, color: '#28a745', marginBottom: 16 }}>$0</div>
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left' }}>
              <li style={{ marginBottom: 8 }}>✅ 5 minutes message duration</li>
              <li style={{ marginBottom: 8 }}>✅ Basic synchronization</li>
              <li style={{ marginBottom: 8 }}>✅ QR code connection</li>
              <li style={{ marginBottom: 8 }}>✅ Light/Dark theme</li>
            </ul>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: 32, borderRadius: 16, textAlign: 'center', color: 'white' }}>
            <h3 style={{ marginBottom: 16 }}>Premium</h3>
            <div style={{ fontSize: 48, marginBottom: 16 }}>$4.99<span style={{ fontSize: 16 }}>/month</span></div>
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left' }}>
              <li style={{ marginBottom: 8 }}>✅ 1h, 24h, unlimited durations</li>
              <li style={{ marginBottom: 8 }}>✅ Advanced synchronization</li>
              <li style={{ marginBottom: 8 }}>✅ Priority support</li>
              <li style={{ marginBottom: 8 }}>✅ Extended discussion time</li>
            </ul>
          </div>
        </div>
        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <p style={{ color: '#6c757d', fontSize: 14 }}>
            <strong>Pay-per-use option:</strong> $0.99 for 7 days or $2.99 for 30 days per discussion
          </p>
        </div>
      </section>

      {/* Use Cases */}
      <section style={{ marginBottom: 60 }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 40, textAlign: 'center' }}>Real-World Use Cases</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 32 }}>
          <div style={{ background: '#f8f9fa', padding: 24, borderRadius: 16 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>📋 Quick Transfers</h3>
            <p style={{ color: '#6c757d' }}>
              Copy a URL on your phone → paste it immediately on your computer without email or cloud storage.
            </p>
          </div>
          <div style={{ background: '#f8f9fa', padding: 24, borderRadius: 16 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>🔐 Sensitive Information</h3>
            <p style={{ color: '#6c757d' }}>
              Exchange sensitive information that auto-deletes after a set time for enhanced security.
            </p>
          </div>
          <div style={{ background: '#f8f9fa', padding: 24, borderRadius: 16 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 16 }}>💬 Anonymous Chat</h3>
            <p style={{ color: '#6c757d' }}>
              Chat with strangers without sharing personal information - perfect for temporary discussions.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={{ marginBottom: 60 }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 40, textAlign: 'center' }}>Frequently Asked Questions</h2>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ marginBottom: 24, padding: 24, background: '#f8f9fa', borderRadius: 12 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 12 }}>What is ScanNChat about?</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              This app allows you to sync your own private messages across multiple devices. You can also create an ephemeral discussion with other users without sharing your personal information. These chats last 7 days and then disappear.
            </p>
          </div>
          <div style={{ marginBottom: 24, padding: 24, background: '#f8f9fa', borderRadius: 12 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 12 }}>How do I create a new private message?</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              To create a new private message, click on the 'Today' button in the 'Private messages' section. Then you can add a new message for this date.
            </p>
          </div>
          <div style={{ marginBottom: 24, padding: 24, background: '#f8f9fa', borderRadius: 12 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 12 }}>How do I launch a new discussion?</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              To launch a new discussion, click on the 'New' button in the 'Discussions' section. Then you can share this discussion link, QR Code or ID to invite another user to discuss with you.
            </p>
          </div>
          <div style={{ marginBottom: 24, padding: 24, background: '#f8f9fa', borderRadius: 12 }}>
            <h3 style={{ color: '#2c3e50', marginBottom: 12 }}>How does the subscription system work?</h3>
            <p style={{ color: '#6c757d', lineHeight: 1.6 }}>
              Monthly subscribers ($4.99/month) can extend any discussion for 7 or 30 days. Non-subscribers can pay $0.99 for 7 days or $2.99 for 30 days per discussion. Only one user needs to pay for the entire discussion.
            </p>
          </div>
        </div>
      </section>

      {/* Support & Contact */}
      <section style={{ marginBottom: 60, background: '#2c3e50', color: 'white', padding: 40, borderRadius: 20 }}>
        <h2 style={{ fontSize: 36, marginBottom: 24, textAlign: 'center' }}>Support & Contact</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 32, textAlign: 'center' }}>
          <div>
            <h3 style={{ marginBottom: 16 }}>📧 Email Support</h3>
            <p><a href="mailto:support@scannchat.com" style={{ color: '#667eea' }}>support@scannchat.com</a></p>
          </div>
          <div>
            <h3 style={{ marginBottom: 16 }}>📱 Phone Support</h3>
            <p><a href="tel:+123456789" style={{ color: '#667eea' }}>+1 (234) 567-89</a></p>
          </div>
          <div>
            <h3 style={{ marginBottom: 16 }}>💬 Live Chat</h3>
            <p>Available 24/7 for premium users</p>
          </div>
        </div>
      </section>

      {/* Donation Section */}
      <section style={{ marginBottom: 60, textAlign: 'center' }}>
        <h2 style={{ fontSize: 36, color: '#2c3e50', marginBottom: 24 }}>Support Our Development</h2>
        <p style={{ fontSize: 18, color: '#6c757d', marginBottom: 32, maxWidth: 600, margin: '0 auto 32px' }}>
          Your donations help us to maintain and improve the app. Any amount is greatly appreciated! 
          You will contribute to improving existing features and developing new ones.
        </p>
        <button style={{ 
          background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)', 
          color: '#fff', 
          border: 'none', 
          padding: '16px 32px', 
          borderRadius: 50, 
          fontSize: 18, 
          cursor: 'pointer',
          fontWeight: 'bold',
          boxShadow: '0 4px 15px rgba(40, 167, 69, 0.4)'
        }}>
          Make a Donation
        </button>
      </section>

      {/* CTA Section */}
      <section style={{ marginBottom: 60, textAlign: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: 60, borderRadius: 20, color: 'white' }}>
        <h2 style={{ fontSize: 36, marginBottom: 24 }}>Join the Community</h2>
        <p style={{ fontSize: 18, marginBottom: 32 }}>
          Hundreds of users already trust us to simplify their daily life.
        </p>
        <button style={{ 
          background: 'white', 
          color: '#667eea', 
          border: 'none', 
          padding: '16px 32px', 
          borderRadius: 50, 
          fontSize: 18, 
          cursor: 'pointer',
          fontWeight: 'bold'
        }}>
          Download Now
        </button>
      </section>

      {/* Footer */}
      <footer style={{ textAlign: 'center', color: '#6c757d', fontSize: 14, marginTop: 40, padding: 20, borderTop: '1px solid #e9ecef' }}>
        <p>Developed by Copy&Paste LLC Company.</p>
        <p style={{ marginTop: 8 }}>
          Available on Mobile (Flutter) & Desktop (Electron) - Windows, macOS, Linux
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
